import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-control-error-display',
  templateUrl: './control-error-display.component.html',
  styleUrls: ['./control-error-display.component.sass'],
})
export class ControlErrorDisplayComponent implements OnInit, OnDestroy {
  languageKey = '';
  private destroy$ = new Subject<void>();

  constructor(
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.languageKey = this.translateService.currentLang || '';
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        this.languageKey = event.lang;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getControlErrors(): string[] {
    let result: string[] = [];
    if (this.control.errors) {
      for (const key in this.control.errors) {
        if (this.customErrors && this.customErrors[key]) {
          result.push(this.customErrors[key]);
        } else if (key.toString() == 'pattern') {
          result.push(
            `error.validation.${key.toString()}.${this.patternMessage}`
          );
        } else {
          result.push(`error.validation.${key.toString()}`);
        }
      }
    }
    return result;
  }

  @Input() control: AbstractControl = new FormControl();
  @Input() patternMessage: any;
  @Input() classes: string = '';
  @Input() customErrors: { [key: string]: string } = {};
}
